module.exports = __webpack_public_path__ + "yadokari-moshi.mp4?efe6329ba7e6fa292c6cca236cedd3ea";


//////////////////
// WEBPACK FOOTER
// ./static/video/yadokari-moshi.mp4
// module id = 208
// module chunks = 0